import service from '@/utils/server';

const modName = '/tms/monthCost/';
//查询
export const pageInfo = data => {
  return service({
    url: modName + 'searchList',
    method: 'post',
    data
  });
};

//导出数据
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//下载文件
export const downloadFile = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'downLoad',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/bill/monthBill/api/index.js